<template>
    <Appstore/>
</template>

<script>
import { Appstore } from 'shared'

export default {
    name: 'appstore2',
    components: {
        Appstore
    },
    created() {
        this.$store.commit('getAppId', [
            {
                value: 6011,
                label: '音乐'
            }
        ])
    }
}
</script>